// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"6d91f5f2","134":"1bb7ce6e","583":"d663bc52","624":"d8dd8c16","787":"dcc73137"}[chunkId] + ".chunk.js";
};